import React, { useContext, useState } from 'react';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { TeaserCard } from 'Components/frameworks/teaser-card/TeaserCard.jsx';

import { truncate } from 'Components/utils/string/string.util';

export function TeaserCardsCard({ card, link = {}, trackingData }) {
  const { image, title, subtitle, seeMoreLabel } = card;

  const [isHovering, setHovering] = useState(false);
  const { isDesktop } = useContext(ResponsiveContext);

  return (
    <TrackClick
      {...link}
      as={link.onClick ? 'button' : DynamicLink}
      className="reset-button block relative text-initial w-full"
      data-testid="TeaserCard"
      onMouseEnter={isDesktop ? () => setHovering(true) : null}
      onMouseLeave={isDesktop ? () => setHovering(false) : null}
      trackingData={trackingData}
    >
      <TeaserCard
        className="w-full"
        isActive={isHovering}
        media={[
          {
            src: image,
          },
        ]}
      >
        {!!title && (
          <p className="reset-paragraph my-4 text-center text-md">{truncate(title, 35, true)}</p>
        )}
        {!!subtitle && (
          <p className="reset-paragraph font-normal font-sans leading-normal my-4 text-base text-gray-darker">
            {truncate(subtitle, 65, true)}
          </p>
        )}
        {!!seeMoreLabel && (
          <p className="reset-paragraph my-4 text-center text-sm underline">{seeMoreLabel}</p>
        )}
      </TeaserCard>
    </TrackClick>
  );
}
